export default "__VITE_ASSET__BjcSVTV3__"